// xams-utils
import { check } from '@xams-utils/check-types';

// xams-entities
import { Version } from '@xams-entities/version';
import { VersionRange } from './index';

// errors
import * as errors from './errors';
var minMaxTypes = function minMaxTypes(min, max) {
  if (check.null(min) && check.null(max)) {
    throw errors.BOTH_VERSIONS_NULL;
  }
};
var minMaxValues = function minMaxValues(min, max) {
  if (check.assigned(min) && check.assigned(max)) {
    if (Version.equals(min, max, true)) {
      throw errors.INVALID_RANGE;
    }
    if (!Version.equals(max, min) && Version.lessThan(max, min)) {
      throw errors.INVALID_RANGE;
    }
  }
};
var minType = function minType(version) {
  if (!check.null(version) && !Version.is(version)) {
    throw errors.MIN_VERSION_TYPE;
  }
};
var maxType = function maxType(version) {
  if (!check.null(version) && !Version.is(version)) {
    throw errors.MAX_VERSION_TYPE;
  }
};
var versionType = function versionType(version) {
  if (!Version.is(version)) {
    throw errors.VERSION_TYPE;
  }
};
var versionRangeType = function versionRangeType(versionRange) {
  if (!VersionRange.is(versionRange)) {
    throw errors.VERSION_RANGE_TYPE;
  }
};
export { minMaxTypes, minMaxValues, minType, maxType, versionType, versionRangeType };